import React from 'react';

import styled from 'styled-components';
import Logo from '../../../images/poinguinie_dev_rm_bg.png'
import { useCookies } from 'react-cookie';

const StyledText = styled.h1`
  font-size: 2.6rem;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  text-align: center;

  background: linear-gradient(90deg, #1e90ff, #00bfff, #4682b4);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;

  text-shadow: 4px 4px 6px rgba(30, 144, 255, 0.5), 
               0px 0px 2px rgba(173, 216, 230, 0.7);

  border: 4px solid rgba(30, 144, 255, 0.7);
  border-radius: 12px;
  padding: 0.8rem 1rem;
  box-shadow: 0px 0px 30px rgba(0, 0, 255, 0.3), 
              inset 0px 0px 10px rgba(255, 255, 255, 0.2);

  @media (max-width: 768px) {
    & {
      font-size: 1.6rem;
    }
  }
`;

const Hero: React.FC = () => {
  // eslint-disable-next-line
  const [cookie, setCookie, removeCookie] = useCookies(['user'])
  const onLogin = () => {
    if(cookie.user as string === "admin") {
      removeCookie("user");
      console.log("logout");
    }
    else {
      const answer = prompt("Give Me Your Answer");
      if(answer === process.env.REACT_APP_DEV_ID) {
        console.log('login');
        setCookie("user", "admin");
      }
    }
    
  }
  return (
    <section id="hero" className="hero">
      <div className="hero-content">
        <div className="hero-text">
          <StyledText>
            Poinguinie
          </StyledText>
          <p><b>Game & Utility</b> Developer.</p>
          <p>Discover my projects and skills. Click below to explore them in detail!</p>
          <a href="#projects" className="btn hero-btn">Explore Projects</a>
        </div>
        <div className="hero-character">
          <img onDoubleClick={onLogin} style={{rotate: "15deg"}} src={Logo} alt="Poinguinie Character" />
        </div>
      </div>
      <div className="hero-decoration">
        <span className="circle circle-1"></span>
        <span className="circle circle-2"></span>
        <span className="circle circle-3"></span>
      </div>
    </section>
  );
};

export default Hero;